function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';
import React, { useEffect, useMemo } from 'react';
import { Badge, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { USER_TYPE, USER_TYPE_TO_DISPLAY_NAME } from '../../../../../constants/user';
import { getUserProfile, setPretendType } from '../../../../../redux/actions';
import { profileSelectors } from '../../../../../redux/selectors/profile';
import routes from '../../../../../routes/constants';
import text from '../../../../../text';
import { clearUser, getUser } from '../../../../../utilities/storage';
import { getUserType, isStaff, isUserAnonymous, isUserStaff } from '../../../../../utilities/user';
import UserAvatar from '../../../../profile/UserAvatar';
import { useRedirect } from '../../../../../hooks/useRedirect';
/* eslint-disable react/prop-types */ var UserNav = function(param) {
    var className = param.className;
    var dispatch = useDispatch();
    var redirect = useRedirect();
    var userProfile = useSelector(profileSelectors.getUserProfile);
    var pretendType = useSelector(profileSelectors.getPretendType);
    var userBadge = useMemo(function() {
        return userProfile && (pretendType !== null && pretendType !== void 0 ? pretendType : getUserType(userProfile));
    }, [
        pretendType,
        userProfile
    ]);
    var canShowPretendUserTypes = useMemo(function() {
        return userProfile && isStaff(userProfile.role);
    }, [
        userProfile
    ]);
    var pretendUserTypes = useMemo(function() {
        return canShowPretendUserTypes ? [
            USER_TYPE.FREE,
            USER_TYPE.ESSENTIALS,
            USER_TYPE.LARKI_SUPPORT
        ].filter(function(type) {
            if (pretendType && type === pretendType) return false;
            if (!pretendType && type === USER_TYPE.LARKI_SUPPORT && isUserStaff(userProfile)) return false;
            return true;
        }) : [];
    }, [
        canShowPretendUserTypes,
        pretendType,
        userProfile
    ]);
    useEffect(function() {
        // todo: why check for full name here?
        if (getUser() && userProfile.full_name === undefined) {
            dispatch(getUserProfile());
        }
    }, [
        dispatch,
        userProfile
    ]);
    return !isEmpty(userProfile) && !isUserAnonymous(userProfile) && /*#__PURE__*/ React.createElement(Nav, {
        className: cn('UserNav', _define_property({}, className, className))
    }, /*#__PURE__*/ React.createElement(Navbar.Collapse, null, /*#__PURE__*/ React.createElement(NavDropdown, {
        alignRight: true,
        title: userBadge ? /*#__PURE__*/ React.createElement("div", {
            className: "avatar-wrapper"
        }, /*#__PURE__*/ React.createElement(UserAvatar, {
            profileImage: userProfile.profile_image,
            crossOrigin: true
        }), /*#__PURE__*/ React.createElement(Badge, {
            className: userBadge
        }, text(userBadge))) : null
    }, /*#__PURE__*/ React.createElement(NavDropdown.Item, {
        onClick: function() {
            return redirect.push(routes.dashboard);
        }
    }, text('dashboard')), /*#__PURE__*/ React.createElement(NavDropdown.Item, {
        onClick: function() {
            return redirect.push(routes.user.profile);
        }
    }, text('account')), /*#__PURE__*/ React.createElement(NavDropdown.Item, {
        href: routes.larkiWebsiteUrl.home,
        target: "_blank"
    }, text('larkiURL')), canShowPretendUserTypes ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(NavDropdown.Divider, null), pretendUserTypes.map(function(type) {
        return /*#__PURE__*/ React.createElement(NavDropdown.Item, {
            key: type,
            onClick: function() {
                return dispatch(setPretendType(type));
            }
        }, text('viewAs', {
            as: USER_TYPE_TO_DISPLAY_NAME[type]
        }));
    })) : null, /*#__PURE__*/ React.createElement(NavDropdown.Divider, null), /*#__PURE__*/ React.createElement(NavDropdown.Item, {
        onClick: function() {
            // also clear it here in case we're on an external domain
            clearUser();
            redirect.push(routes.logout);
        }
    }, text('logout')))));
};
export default UserNav;
